export default __webpack_public_path__ + "static/media/img-0569-finland-premium-face.ab449c5a.png";